import React from "react";

export default function BlueLoader({
  top,
  width,
  right,
  left,
  z = 80,
  position = "absolute",
}) {
  return (
    <div>
      <img
        src="../assets/images/loader/blueloader.svg"
        alt=""
        style={{
          width: `${width}vw`,
          top: `${top}%`,
          right: `${right}%`,
          left: `${left}%`,
          zIndex: `${z}`,
          position: `${position}`,
        }}
        className={``}
      />
    </div>
  );
}
